import { useEffect, useCallback } from 'react'

import { selectCreditCard, selectVehicle } from 'booking/actions'
import { clearPending } from 'api/actions'
import { userSelector, addressToStringSelector } from 'auth/selectors'
import { creditCardsSelector } from 'credit-cards/selectors'
import { allowPurchaseSingleTicketSelector, makePurchasePendingSelector } from 'booking/selectors'
import { selectedCreditCardSelector, selectedVehicleSelector, parkingModeSelector } from 'booking/selectors'
import useBookingValidation from 'shared/hooks/useBookingValidation'
import useOnPayForParking from 'shared/hooks/useOnPayForParking'

const withPurchase = WrappedComponent => props => {
    const {
        user,
        rate,
        clearPending,
        selectedCreditCard,
        selectCreditCard,
        selectedVehicle,
        makePurchasePending,
        allowPurchase,
        cards,
    } = props

    const { updateValidation } = useBookingValidation(rate)
    const { onPayForParkingClick } = useOnPayForParking()

    useEffect(() => {
        clearPending(['makePurchase'])
    }, [])

    const setCreditCard = useCallback(
        card => {
            selectCreditCard(card)
        },
        [selectCreditCard]
    )

    useEffect(() => {
        updateValidation({
            selectCardError: false,
        })

        if (cards.length > 0 || (selectedCreditCard && !selectedCreditCard.default)) {
            const card = cards.find(card => card?.default) || cards[0]
            selectCreditCard(card?.id || null)
        }
    }, [selectCreditCard, cards])

    return (
        <WrappedComponent
            setCreditCard={setCreditCard}
            onPayForParkingClick={onPayForParkingClick}
            user={user}
            selectedCreditCard={selectedCreditCard}
            selectedVehicle={selectedVehicle}
            makePurchasePending={makePurchasePending}
            allowPurchase={allowPurchase}
            {...props}
        />
    )
}

export default WrappedComponent =>
    compose(
        connect(
            createStructuredSelector({
                user: userSelector,
                selectedCreditCard: selectedCreditCardSelector,
                selectedVehicle: selectedVehicleSelector,
                makePurchasePending: makePurchasePendingSelector,
                allowPurchase: allowPurchaseSingleTicketSelector,
                cards: creditCardsSelector,
                parkingMode: parkingModeSelector,
                deliveryAddress: addressToStringSelector,
            }),
            {
                selectCreditCard,
                selectVehicle,
                clearPending,
            }
        )
    )(withPurchase(WrappedComponent))
